<aside id="mainCollectionPointList" class="col-md-12 mb-0 h-100-margin">
  <div class="container-list h-100-margin">
    <div class="container-list-header">
      <div class="row m-0 p-0 pb-3 align-items-baseline justify-content-between">
        <app-list-filter [options]="optionsFilter" [filterBy]="'vehicle'"
          (refreshList)="getVehicles($event)"></app-list-filter>
        <button mat-raised-button permission-display [module]="permission.administration.module"
          [functionality]="permission.administration.downloadFileRegistreBank" class="primary-secondary" color="primary"
          title="Inscribir cuentas" (click)="registerBankAccounts()" *ngIf="itemsSelecteds?.length">
          <i class="fas fa-plus"></i> Inscribir cuentas
        </button>
        <button matTooltip="Crear Vehículo" mat-raised-button color="primary" permission-display
          [module]="permission.administration.module" [functionality]="permission.administration.createVehicle"
          class="bg-color-primary button-width-auto text-bold" (click)="goToCreate()">
          <i class="fas fa-plus-circle mr-2 d-none d-sm-inline"></i>
          <span>Crear vehículo</span>
        </button>
      </div>
    </div>
    <div class="container-list-body mt-4 mt-lg-0" infinite-scroll *ngIf="service.paginationList.getList().length"
      [infiniteScrollDistance]="service.paginationList.getScrollDistance()"
      [infiniteScrollThrottle]="service.paginationList.getThrottle()" [scrollWindow]="false"
      (scrolled)="onScrollDown()">
      <div class="col-md-12 mb-md-0 mb-12 p-0 pl-2"
        *ngFor="let vehicle of service.paginationList.getList(); let i = index;">
        <app-item-vehicle [vehicle]="vehicle" select-item-list [selectableItem]="getActiveItem(vehicle)"
          [checked]="vehicle?.checked" [item]="vehicle" [list]="service.paginationList.getList()"
          (onSelectItem)="onSelectItem($event)">
        </app-item-vehicle>
      </div>
    </div>
    <div *ngIf="!service.paginationList.getList().length" class="container_no_results h-100">
      <div class="icon"><i class="fas fa-calendar-times"></i></div>
      <h4 class="text-bold text-center">No hay resultados que coincidan con la búsqueda</h4>
    </div>
    <div class="my-1 d-flex justify-content-start">
      <div class="conv-btn" (click)="openConventions()">
        <i class="fas fa-circle"></i> Convenciones
      </div>
    </div>
  </div>
</aside>